var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-upload-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-upload-icon-group2",
    transform: "translate(-954.000000, -416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-upload-icon-group3",
    transform: "translate(954.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "file-upload-icon-polygon1",
    points: "0 0 48 0 48 48 0 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,6 C40.2,6 42,7.8 42,10 L42,10 L42,38 C42,40.2 40.2,42 38,42 L38,42 L10,42 C7.8,42 6,40.2 6,38 L6,38 L6,10 C6,7.8 7.8,6 10,6 L10,6 L24.3916435,5.99946238 C24.1397865,6.54848152 24,7.15549424 24,7.79393939 L24,21.7333333 C24,25.1233939 26.8625455,27.8666667 30.4,27.8666667 C33.9374545,27.8666667 36.8,25.1233939 36.8,21.7333333 L36.8,8.90909091 L35.0545455,8.90909091 L35.0545455,21.7333333 C35.0545455,24.1978182 32.9716364,26.1939394 30.4,26.1939394 C27.8283636,26.1939394 25.7454545,24.1978182 25.7454545,21.7333333 L25.7454545,7.79393939 C25.7454545,7.11051082 26.0024915,6.48426533 26.4289147,5.99920168 L30.8801762,5.99920168 C31.3065994,6.48426533 31.5636364,7.11051082 31.5636364,7.79393939 L31.5636364,19.5030303 C31.5636364,20.1163636 31.04,20.6181818 30.4,20.6181818 C29.76,20.6181818 29.2363636,20.1163636 29.2363636,19.5030303 L29.2363636,8.90909091 L27.4909091,8.90909091 L27.4909091,19.5030303 C27.4909091,21.0419394 28.7941818,22.2909091 30.4,22.2909091 C32.0058182,22.2909091 33.3090909,21.0419394 33.3090909,19.5030303 L33.3090909,7.79393939 C33.3090909,7.15549424 33.1693044,6.54848152 32.9174474,5.99946238 Z",
    id: "file-upload-icon-path1",
    fill: "#ACB3C3",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.1befcbaf.svg";
export { ForwardRef as ReactComponent };